// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseRegion } from './ResponseRegion';
import {
  ResponseRegionFromJSON,
  ResponseRegionFromJSONTyped,
  ResponseRegionToJSON,
  ResponseRegionToJSONTyped,
} from './ResponseRegion';

/**
 *
 * @export
 * @interface ResponseRegionList
 */
export interface ResponseRegionList {
  /**
   *
   * @type {Array<ResponseRegion>}
   * @memberof ResponseRegionList
   */
  items?: Array<ResponseRegion>;
}

/**
 * Check if a given object implements the ResponseRegionList interface.
 */
export function instanceOfResponseRegionList(
  value: object,
): value is ResponseRegionList {
  return true;
}

export function ResponseRegionListFromJSON(json: any): ResponseRegionList {
  return ResponseRegionListFromJSONTyped(json, false);
}

export function ResponseRegionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRegionList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(ResponseRegionFromJSON),
  };
}

export function ResponseRegionListToJSON(json: any): ResponseRegionList {
  return ResponseRegionListToJSONTyped(json, false);
}

export function ResponseRegionListToJSONTyped(
  value?: ResponseRegionList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(ResponseRegionToJSON),
  };
}
